import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, watch, onBeforeUnmount, onMounted } from 'vue'
import { PaginationData } from '@/api/operation/customer';
import storage from 'baimahu/storage';
import { setRegion } from '@/view/repository/region';
import { getWarehouse, postWarehouse, putWarehouse, putWarehouseStatus } from '../api/warehouse'
import { queryFactory } from '@/api/factory/factory';
import { message } from 'ant-design-vue';
import { Coloumns, Validator } from '../types'
import { TableData, Search, FormList } from '../types/warehouse'


export default /*#__PURE__*/_defineComponent({
  __name: 'Warehouse',
  setup(__props) {

const model_layout: any = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
};
const channel_table_data = ref<PaginationData<TableData>>({
    current: 1,
    last: 0,
    total: 0,
    limit: 10,
    detail: []
})
const validator_list = reactive({
    name: {
        message: '请输入仓库名称',
        status: "success",
        help: ""
    },
    factory_id: {
        message: '请输入所属工厂',
        status: 'success',
        help: ''
    },
    contact_mobile: {
        message: '请输入正确手机号',
        status: "success",
        help: "",
        validate: (value: string): boolean => {
            if (value === '' || checkTel(value)) {
                return !!value;
            } else {
                return false;
            }
        },
    },
    city: {
        message: '请输入正确仓库城市',
        status: "success",
        help: "",
        validate: (value: string[]) => value.length === 3
    },
    address: {
        message: '请输入仓库地址',
        status: "success",
        help: ""
    },
})
const is_loading = ref<boolean>(false)
const modal_visible = ref<boolean>(false)
const channel_columns = ref<Coloumns[]>([
    {
        title: '仓库编号',
        dataIndex: 'id',
        key: 'id',
        width: '13%',
    },
    {
        title: '仓库名称',
        dataIndex: 'name',
        key: 'name',
        width: '18%',
    },
    {
        title: '联系人',
        dataIndex: 'contact_name',
        key: 'contact_name',
        width: '10%',
    },
    {
        title: '所属工厂',
        dataIndex: 'factory.name',
        key: 'factory.name',
        width: '12%',
    },
    {
        title: '联系方式',
        dataIndex: 'contact_mobile',
        key: 'contact_mobile',
        width: '18%',
    },
    {
        title: '仓库地址',
        dataIndex: 'province_name',
        key: 'province_name',
        width: '14%',
        scopedSlots: {
            customRender: 'province_name',
        },
    },
    {
        title: '仓库容量(m3)',
        dataIndex: 'volume',
        key: 'volume',
        width: '14%',
    },
    {
        title: '状态',
        dataIndex: 'status',
        key: 'status',
        width: '14%',
        scopedSlots: {
            customRender: 'status',
        },
    },
    {
        title: '创建时间',
        dataIndex: 'create_time',
        key: 'create_time',
        width: '14%',
        scopedSlots: {
            customRender: 'create_time',
        },
    },
    {
        title: '操作',
        dataIndex: 'city_name',
        key: 'city_name',
        width: '14%',
        scopedSlots: {
            customRender: 'operate',
        },
    }
])
const editStatus = ref<boolean>(false)
const editId = ref<number>()
const searchList: Search = reactive({
    search: '',
    date: []
})
const formList: FormList = reactive({
    factory_id: undefined,
    name: '',
    contact_name: '',
    contact_mobile: '',
    address: '',
    city: [],
    volume: '',
    status: true
})
const addressList = ref<any[]>([])
const province_list = ref("");
function checkTel(value: any) {
    const isMob: any = /^((\+?86)|(\(\+86\)))?(13[0123456789][0-9]{8}|15[0123456789][0-9]{8}|18[02356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/;
    if (isMob.test(value)) {
        return true;
    } else {
        return false;
    }
}
function initformList() {
    formList.factory_id = undefined,
        formList.name = '',
        formList.contact_name = '',
        formList.contact_mobile = '',
        formList.address = '',
        formList.city = [],
        formList.volume = '',
        formList.status = true
    Object.keys(validator_list).forEach(item => {
        validator_list[item].status = 'success'
        validator_list[item].help = ''
    })
}
function initSearch() {
    searchList.search = ''
    searchList.date = []
    search()

}
function search() {
    wareHouseList()
}
async function wareHouseList(current: number = 1) {
    is_loading.value = true
    const { search, date } = searchList
    const send_data = {
        search,
        start_time: date[0] ? date[0].startOf('day').unix() : '',
        end_time: date[1] ? date[1].endOf('day').unix() : ''
    }
    const res = await getWarehouse(send_data, current)
    channel_table_data.value = res.data
    is_loading.value = false
}

function paginationOption(data: PaginationData<TableData>) {
    return {
        current: data.current || 0,
        pageSize: data.limit || 0,
        showTotal: () => `共${data.total}条, 每页${data.limit}条`,
        total: data.total || 0,
    };
}
function handleTableChange(paginationa: any) {
    wareHouseList(paginationa.current)
}
function handleAdd() {
    editStatus.value = false
    modal_visible.value = true
    Object.keys(validator_list).forEach(item => {
        validator_list[item].status = 'success'
        validator_list[item].help = ''
    })
}
function modalCancel() {
    initformList()

    modal_visible.value = false
}
function edit(data: TableData) {
    editStatus.value = true
    editId.value = data.id
    const {
        factory_id, name, contact_name, contact_mobile, address, province_name, city_name, area_name, volume, status
    } = data
    formList.factory_id = factory_id,
        formList.name = name,
        formList.contact_name = contact_name,
        formList.contact_mobile = contact_mobile,
        formList.address = address,
        formList.city = [province_name, city_name, area_name],
        formList.volume = volume,
        formList.status = status
    modal_visible.value = true

}
async function fetchWareList(current: number = 1) {
    const res = await queryFactory(current, { limit: 1000 });
    addressList.value = res.detail.map((item) => {
        return {
            name: item.name,
            id: item.id
        }
    })
}
async function setStatus(params: TableData) {
    const send_data = {
        status: params.status ? 2 : 1
    }
    const res = await putWarehouseStatus(send_data, params.id)
    if (res.status === 200) {
        message.success('成功')
        await wareHouseList()
    } else {
        message.error('失败')
    }
}
async function handleOk() {
    Object.keys(validator_list).map((item) => {
        ruleVerify(formList[item], item)
    })
    const formStatus = Object.keys(validator_list).every((item) => validator_list[item].status === 'success')
    if (!formStatus) return message.error('必填项未填写或填写错误')

    const send_data: any = {
        ...formList,
        province_name: formList.city[0],
        city_name: formList.city[1],
        area_name: formList.city[2],
        status: formList.status ? 1 : 2
    }
    delete send_data.city
    Object.keys(send_data).forEach((item) => {
        send_data[item] === '' ? delete send_data[item] : false
    })
    let res
    editStatus.value ? res = await putWarehouse(send_data, editId.value) : res = await postWarehouse(send_data)
    if (res.status === 200) {
        message.success(editStatus.value ? '编辑成功' : '新建成功')
        await wareHouseList()
        modal_visible.value = false
        initformList()
    } else {
        message.error(res.message)
    }

}
const watchList = Object.keys(validator_list).map((item) => {
    return watch(() => formList[item], (newValue) => {
        ruleVerify(newValue, item)
    })
})
function ruleVerify(newValue: any, item: string) {
    const success = {
        ...validator_list[item],
        status: "success",
        help: ""
    },
        error = {
            ...validator_list[item],
            status: "error",
            help: validator_list[item].message
        }
    if (validator_list[item].validate) {
        const status = validator_list[item].validate(newValue)
        status ? validator_list[item] = success : validator_list[item] = error
    } else {
        newValue ? validator_list[item] = success : validator_list[item] = error
    }
}
onBeforeUnmount(() => {
    watchList.forEach((item) => {
        item()
    })
})
async function init() {
    await setRegion();
    await wareHouseList()
    await fetchWareList()
    province_list.value = storage.getItem('region_list')
}
onMounted(()=>{
    init()
})

return { __sfc: true,model_layout, channel_table_data, validator_list, is_loading, modal_visible, channel_columns, editStatus, editId, searchList, formList, addressList, province_list, checkTel, initformList, initSearch, search, wareHouseList, paginationOption, handleTableChange, handleAdd, modalCancel, edit, fetchWareList, setStatus, handleOk, watchList, ruleVerify, init }
}

})